import { stepsEnum } from "../constants/copyPlanConstants";

const { PLAN, ORDER, FINISH } = stepsEnum;

export const isStepOptional = step => step === ORDER;
export const isCancelButtonVisiable = step => step !== PLAN && step !== FINISH;
export const isPauseButtonVisiable = step => step === ORDER;
export const isLastStep = step => step === FINISH;
export const isStepSkipped = (step, skipped) => skipped.has(step);
